module.exports = "<div class=\"textarea-counter\">\n  <textarea #messagefield name=\"message\" class=\"rounded-0 border-0\" [(ngModel)]='message' \n    [attr.placeholder]=\"placeholder\" [maxLength]=\"maxLength\" (keyup)=\"setMessage()\"></textarea>\n  <div class='message-counter text-right pt-2 pb-2 pr-3'>\n    <span>Characters remaining: {{ maxLength - messagefield.value.length }}</span>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/textarea-counter/textarea-counter.component.html
// module id = ./src/app/shared/components/textarea-counter/textarea-counter.component.html
// module chunks = main